// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a3fbc197","651":"d9833c82","858":"94b6a758"}[chunkId] + ".chunk.js";
};